const c = {
  langQueryParameterName: "lang" as const,
};

export default c;
